export default __webpack_public_path__ + "images/load.3865ba4981fff08f54de9d22a56f6f53.png";